module.exports = __webpack_public_path__ + "static/media/icon-arrow-select-solid.ddf9e770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-arrow-select-solid.svg
// module id = 686
// module chunks = 0